import { get } from "../client";
import { GET_MESSAGE_LOG } from "../routes";

export default {
  get_message_log: async (page = 1, limit = 30) =>
    await get(GET_MESSAGE_LOG(page, limit)),
};
